/*
 * Elysian Edge redesign: <ee-tabs> (Sprint 4).
 *
 * Progressive enhancement for sections/ee-tabbed-collection.liquid. The server renders every panel (inactive ones carry `hidden`),
 * so this only switches them: no fetch, no re-render.
 *
 * Pattern: WAI-ARIA tabs with automatic activation. role=tablist / tab / tabpanel, aria-selected, aria-controls (+ aria-labelledby on the panel),
 * roving tabindex (only the selected tab is in the Tab order), ArrowLeft / ArrowRight (wrap), Home / End.
 * In the theme editor, selecting a tab block (shopify:block:select) shows its panel.
 */
(function () {
  if (window.customElements.get("ee-tabs")) return

  class EETabs extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[role="tablist"]')
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'))
      if (!this.list || !this.tabs.length) return
      this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute("aria-controls")))

      this.onClick = (event) => {
        const index = this.tabs.indexOf(event.target.closest('[role="tab"]'))
        if (index > -1) this.select(index)
      }
      this.onKeydown = (event) => {
        const current = this.tabs.indexOf(event.target.closest('[role="tab"]'))
        if (current < 0 || event.altKey || event.ctrlKey || event.metaKey) return
        const last = this.tabs.length - 1
        let next
        switch (event.key) {
          case "ArrowRight":
            next = current === last ? 0 : current + 1
            break
          case "ArrowLeft":
            next = current === 0 ? last : current - 1
            break
          case "Home":
            next = 0
            break
          case "End":
            next = last
            break
          default:
            return
        }
        event.preventDefault()
        this.select(next, true)
      }
      this.onBlockSelect = (event) => {
        const index = this.tabs.indexOf(event.target)
        if (index > -1) this.select(index)
      }

      this.list.addEventListener("click", this.onClick)
      this.list.addEventListener("keydown", this.onKeydown)
      this.addEventListener("shopify:block:select", this.onBlockSelect)

      const selected = this.tabs.findIndex((tab) => tab.getAttribute("aria-selected") === "true")
      this.select(selected > -1 ? selected : 0)
    }

    disconnectedCallback() {
      if (!this.list) return
      this.list.removeEventListener("click", this.onClick)
      this.list.removeEventListener("keydown", this.onKeydown)
      this.removeEventListener("shopify:block:select", this.onBlockSelect)
    }

    select(index, focus) {
      this.tabs.forEach((tab, i) => {
        const on = i === index
        tab.setAttribute("aria-selected", on ? "true" : "false")
        tab.tabIndex = on ? 0 : -1
        if (this.panels[i]) this.panels[i].hidden = !on
      })
      const tab = this.tabs[index]
      if (focus) tab.focus()
      this.reveal(tab)
    }

    /* The list scrolls sideways on phones: keep the selected tab inside it without moving the page. */
    reveal(tab) {
      const list = this.list
      if (list.scrollWidth <= list.clientWidth) return
      const left = tab.offsetLeft
      const right = left + tab.offsetWidth
      if (left < list.scrollLeft) list.scrollLeft = left
      else if (right > list.scrollLeft + list.clientWidth) list.scrollLeft = right - list.clientWidth
    }
  }

  window.customElements.define("ee-tabs", EETabs)
})()
